import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  Paper
} from "@mui/material";
import emailjs from "@emailjs/browser";

function CareerForm() {

  const [fileName, setFileName] = useState("");

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFileName(file.name);
    }
  };

  const submitApplication = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_qjj13gq",
        "template_b0qsm4d",
        e.target,
        "user_KPZSDs2FFlA5SdfXYQjwG"
      )
      .then(
        () => {
          alert("Application submitted successfully!");
        },
        (error) => {
          console.log(error);
        }
      );

    e.target.reset();
    setFileName("");
  };

  return (
    <Paper sx={{ p: 4, mt: 6 }}>

      <Typography
        variant="h5"
        fontWeight="bold"
        textAlign="center"
        gutterBottom
      >
        Apply For Job
      </Typography>

      <Box
        component="form"
        onSubmit={submitApplication}
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 3
        }}
      >

        <TextField
          label="Name"
          name="name"
          required
          fullWidth
        />

        <TextField
          label="Email"
          name="email"
          required
          fullWidth
        />

        <TextField
          label="Phone"
          name="phone"
          required
          fullWidth
        />

        {/* Resume Upload */}

        <Button
          variant="outlined"
          component="label"
        >
          Upload Resume (PDF)

          <input
            type="file"
            hidden
            accept=".pdf"
            name="resume"
            onChange={handleFileChange}
          />
        </Button>

        {fileName && (
          <Typography variant="body2">
            Selected: {fileName}
          </Typography>
        )}

        <Button
          variant="contained"
          type="submit"
          size="large"
        >
          Submit
        </Button>

      </Box>

    </Paper>
  );
}

export default CareerForm;